import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { LinkedinLogo, Envelope } from "@phosphor-icons/react";

const LOGO_URL = "/gjc-logo.svg";
const CONTACT_EMAIL = "contacto@gjcenertec.com";

export default function Footer() {
  const { t } = useLang();

  const companyLinks = [
    { label: t.nav.about, path: "/about" },
    { label: t.nav.whyGJC, path: "/why-gjc" },
    { label: t.nav.contact, path: "/contact" },
  ];

  const solutionLinks = [
    { label: t.nav.solutions, path: "/solutions" },
    { label: t.nav.markets, path: "/markets" },
  ];

  return (
    <footer data-testid="main-footer" className="bg-[#0A192F] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <img
              src={LOGO_URL}
              alt="GJC Enertec"
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-sm text-slate-400 leading-relaxed mt-3">
              {t.footer.tagline}
            </p>
          </div>

          {/* Company links */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-[#0D9488] mb-5">
              {t.footer.nav.company}
            </h4>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    data-testid={`footer-link-${link.path.slice(1)}`}
                    className="text-sm text-slate-400 hover:text-white transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Solutions links */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-[#0D9488] mb-5">
              {t.footer.nav.solutions}
            </h4>
            <ul className="space-y-3">
              {solutionLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    data-testid={`footer-link-${link.path.slice(1)}`}
                    className="text-sm text-slate-400 hover:text-white transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-[#0D9488] mb-5">
              {t.footer.nav.connect}
            </h4>
            <div className="space-y-3">
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                data-testid="footer-email"
                className="flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors duration-200"
              >
                <Envelope size={18} /> {CONTACT_EMAIL}
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                className="flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors duration-200"
              >
                <LinkedinLogo size={18} /> LinkedIn
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-700 mt-12 pt-8 text-center">
          <p className="text-xs text-slate-500">
            &copy; {new Date().getFullYear()} {t.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
}
